(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AnomalyCategoryDeleteController',AnomalyCategoryDeleteController);

    AnomalyCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'AnomalyCategory'];

    function AnomalyCategoryDeleteController($uibModalInstance, entity, AnomalyCategory) {
        var vm = this;

        vm.anomalyCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AnomalyCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
